export default __webpack_public_path__ + "static/media/BIFI.32693ccb.png";